import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: 0,
};

// Customer reservation data is intentionally kept in Redux memory only.
// Persisting it in localStorage can leak the previous customer's name/email/token
// into a later booking made from the same browser or device.
const initialStateCreateReservation = {
  value: 0,
};

export const closedOpenExceptionsDatePickerSlice = createSlice({
  name: "openClosedExceptions",
  initialState,
  reducers: {
    openClosedExceptionsRequest: (state) => {
      state.isLoading = true;
    },
    openClosedExceptionsSucess: (state, action) => {
      state.openClosedExceptions = action.payload;
      state.isLoading = false;
    },
    openClosedExceptionsError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const reservationBlockedWeekdaysSlice = createSlice({
  name: "reservationBlockedWeekdays",
  initialState,
  reducers: {
    reservationBlockedWeekdaysRequest: (state) => {
      state.isLoading = true;
      state.error = false;
    },
    reservationBlockedWeekdaysSucess: (state, action) => {
      state.blockedWeekdays = action.payload;
      state.isLoading = false;
    },
    reservationBlockedWeekdaysError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    // Checking if restaurant is still open in the correct time zone
    isRestaurantOpenTodayRequest: (state) => {
      state.loadingIsRestaurantOpen = true;
      state.errorIsRestaurantOpen = false;
    },
    isRestaurantOpenTodaySucess: (state, action) => {
      state.isRestaurantOpen = action.payload;
      state.loadingIsRestaurantOpen = false;
    },
    isRestaurantOpenTodayError: (state, action) => {
      state.errorIsRestaurantOpen = action.payload;
      state.loadingIsRestaurantOpen = false;
    },
    // Checking if restaurant is still open in the correct time zone
    restaurantTimeZoneRequest: (state) => {
      state.loadingRestaurantTimeZone = true;
      state.errorIsRestaurantTimeZone = false;
    },
    restaurantTimeZoneSucess: (state, action) => {
      state.restaurantTimeZone = action.payload;
      state.loadingRestaurantTimeZone = false;
    },
    restaurantTimeZoneError: (state, action) => {
      state.errorIsRestaurantTimeZone = action.payload;
      state.loadingRestaurantTimeZone = false;
    },
  },
});

export const reservationZoneSlice = createSlice({
  name: "reservationZones",
  initialState,
  reducers: {
    reservationZoneRequest: (state) => {
      state.isZonesLoading = true;
    },
    reservationZoneSucess: (state, action) => {
      state.zones = action.payload;
      state.isZonesLoading = false;
    },
    reservationZoneError: (state, action) => {
      state.zonesError = action.payload;
      state.isZonesLoading = false;
    },
  },
});

export const openTimeSlice = createSlice({
  name: "openTime",
  initialState,
  reducers: {
    openTimeRequest: (state) => {
      state.isLoading = true;
      state.openTime = [];
    },
    openTimeSucess: (state, action) => {
      state.openTime = action.payload;
      state.isLoading = false;
    },
    openTimeError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const createReservationSlice = createSlice({
  name: "createReservation",
  initialState: initialStateCreateReservation,
  reducers: {
    createReservationRequest: (state) => {
      state.isLoading = true;
      state.reservation_created = false;
      state.createReservationFailed = false;
      state.createReservationSuccess = false;
      state.error = false;
    },
    createReservationSucess: (state, action) => {
      state.reservation_created = action.payload;
      state.isLoading = false;
      state.error = false;
      state.createReservationFailed = false;
      state.createReservationSuccess = true;
    },
    createReservationError: (state, action) => {
      state.error = action.payload;
      state.createReservationSuccess = false;
      state.createReservationFailed = true;
      state.isLoading = false;
    },
    createReservationSuccessErrorReset: (state) => {
      state.error = false;
      state.createReservationSuccess = false;
      state.createReservationFailed = false;
      state.isLoading = false;
    },

    // update reservation
    reservationUpdateStart: (state) => {
      state.reservationUpdateIsLoading = true;
    },
    reservationUpdateSucess: (state, action) => {
      state.reservationUpdate = action.payload;
      state.reservationUpdateIsLoading = false;
    },
    reservationUpdateError: (state, action) => {
      state.reservationUpdateError = action.payload;
      state.reservationUpdateIsLoading = false;
    },
    // postPhoneConfirmation
    postPhoneConfirmationStart: (state) => {
      state.isPhoneConfirmationLoading = true;
    },
    postPhoneConfirmationSucess: (state, action) => {
      state.phoneConfirmation = action.payload;
      state.isPhoneConfirmationLoading = false;
    },
    postPhoneConfirmationError: (state, action) => {
      state.phoneConfirmationError = action.payload;
      state.isPhoneConfirmationLoading = false;
    },
    postPhoneConfirmationReset: (state) => {
      state.phoneConfirmationError = false;
      state.isPhoneConfirmationLoading = false;
      state.phoneConfirmation = false;
    },
    // postResendPhoneConfirmation
    postResendPhoneConfirmationStart: (state) => {
      state.isResendPhoneConfirmationLoading = true;
    },
    postResendPhoneConfirmationSucess: (state, action) => {
      state.resendPhoneConfirmation = action.payload;
      state.isResendPhoneConfirmationLoading = false;
    },
    postResendPhoneConfirmationError: (state, action) => {
      state.resendPhoneConfirmationError = action.payload;
      state.isResendPhoneConfirmationLoading = false;
    },
    // postCheckCancel
    postCheckCancelStart: (state) => {
      state.checkCancel = false;
      state.isCheckCancelLoading = true;
    },
    postCheckCancelSucess: (state, action) => {
      state.checkCancel = action.payload;
      state.isCheckCancelLoading = false;
    },
    postCheckCancelError: (state, action) => {
      state.checkCancelnError = action.payload;
      state.isCheckCancelLoading = false;
    },
    // postCheckCancel
    postReconfirmationByClient: (state) => {
      state.reconfirmationByClient = false;
      state.reconfirmationByClientLoading = true;
    },
    postReconfirmationByClientSucess: (state, action) => {
      state.reconfirmationByClient = action.payload;
      state.reconfirmationByClientLoading = false;
    },
    postReconfirmationByClientError: (state, action) => {
      state.reconfirmationByClientError = action.payload;
      state.reconfirmationByClientLoading = false;
    },

    // reset
    resetReservationError: () => {
      return {};
    },
  },
});

export const cancelReservationSlice = createSlice({
  name: "cancelReservation",
  initialState,
  reducers: {
    cancelReservationRequest: (state) => {
      state.isLoadingCancel = true;
    },
    cancelReservationSucess: (state, action) => {
      state.cancelMessage = action.payload;
      state.isLoadingCancel = false;
    },
    cancelReservationError: (state, action) => {
      state.error = action.payload;
      state.isLoadingCancel = false;
    },
  },
});

export const editReservationSlice = createSlice({
  name: "editReservation",
  initialState,
  reducers: {
    editReservationRequest: (state) => {
      state.isLoadingEditReservation = true;
    },
    editReservationSucess: (state, action) => {
      state.editReservation = action.payload;
      state.isLoadingEditReservation = false;
    },
    editReservationError: (state, action) => {
      state.errorEditReservations = action.payload;
      state.isLoadingEditReservation = false;
    },
  },
});

export const reservationCustomersMenuSlice = createSlice({
  name: "cancelReservation",
  initialState,
  reducers: {
    getReservationCustomerRequest: (state, action) => {
      const { token, requestId, showLoader = false } = action.payload || {};
      const normalizedToken = token == null ? "" : String(token);

      state.isLoading = true;
      state.error = false;
      state.requestedToken = normalizedToken;
      state.requestId = requestId;

      // Never keep a different customer's reservation visible while a new
      // reservation token is being loaded.
      if (
        !state.reservation ||
        String(state.reservation.token || "") !== normalizedToken
      ) {
        state.reservation = null;
      }

      if (showLoader) {
        state.isCustomerLoader = true;
      }
    },
    getReservationCustomerSucess: (state, action) => {
      const { reservation, token, requestId } = action.payload || {};
      const normalizedToken = token == null ? "" : String(token);

      // Ignore stale HTTP responses from a reservation that is no longer the
      // active request. This prevents reservation A overwriting reservation B.
      if (
        state.requestId !== requestId ||
        state.requestedToken !== normalizedToken
      ) {
        return;
      }

      if (
        !reservation ||
        String(reservation.token || "") !== normalizedToken
      ) {
        state.reservation = null;
        state.error = "Reservation token mismatch.";
        state.isLoading = false;
        state.isCustomerLoader = false;
        return;
      }

      state.reservation = reservation;
      state.error = false;
      state.isLoading = false;
      state.isCustomerLoader = false;
    },
    getReservationCustomerError: (state, action) => {
      const { error, token, requestId } = action.payload || {};
      const normalizedToken = token == null ? "" : String(token);

      if (
        state.requestId !== requestId ||
        state.requestedToken !== normalizedToken
      ) {
        return;
      }

      state.error = error;
      state.reservation = null;
      state.isLoading = false;
      state.isCustomerLoader = false;
    },
    // Special Loader for customer menu so it doesnt load the loader component wen the page it's autoupdating itself
    startCustomerMenuLoader: (state, action) => {
      state.isCustomerLoader = true;
    },
    stopCustomerMenuLoader: (state, action) => {
      state.isCustomerLoader = false;
    },
    resetReservationCustomerMenu: () => {
      return {};
    },
  },
});

export const reservationLimitPeopleBabySlice = createSlice({
  name: "reservationLimitPeopleBaby",
  initialState,
  reducers: {
    getPeopleBabyRequest: (state) => {
      state.isLoading = true;
    },
    getLimitsPeopleBabySucess: (state, action) => {
      state.limitPeopleBaby = action.payload;
      state.isLoading = false;
    },
    getPeopleBabyError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const reservationActiveSlice = createSlice({
  name: "reservationActive",
  initialState,
  reducers: {
    getReservationActiveRequest: (state) => {
      state.isActive = true;
    },
    getReservationActiveError: (state, action) => {
      state.error = action.payload;
    },
    getReservationDeactivateRequest: (state, action) => {
      state.isActive = false;
    },
  },
});

export const reservationPhoneOrEmailConfirmationSlice = createSlice({
  name: "reservationPhoneOrEmailConfirmation",
  initialState,
  reducers: {
    getPhoneOrEmailConfirmationRequest: (state) => {
      state.isPhoneOrEmailConfirmationLoading = true;
    },
    getPhoneOrEmailConfirmationSucess: (state, action) => {
      state.phoneOrEmailConfirmation = action.payload;
      state.isPhoneOrEmailConfirmationLoading = false;
    },
    getPhoneOrEmailConfirmationError: (state, action) => {
      state.phoneOrEmailConfirmationError = action.payload;
      state.isPhoneOrEmailConfirmationLoading = false;
    },
  },
});
